import { render, staticRenderFns } from "./shengshixian.vue?vue&type=template&id=42f96dc7&scoped=true"
import script from "./shengshixian.vue?vue&type=script&lang=js"
export * from "./shengshixian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f96dc7",
  null
  
)

export default component.exports